// JobSeekerAuth.js
import React, { useState ,useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase"; 
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import BackButton from "./BackButton";
import { useAuth } from "../context/AuthContext";
import "./JobSeekerAuth.css";

function JobSeekerAuth() {
  const { currentUser } = useAuth(); 
  const [isSignup, setIsSignup] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser) {
      navigate("/mv-profile");
    }
  }, [currentUser, navigate]);

  const handleClose = () => {
    navigate("/mv-profile"); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let userCredential;

      if (isSignup) {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);
        console.log("User signed up:", userCredential.user);

        await setDoc(doc(db, "users", userCredential.user.uid), {
          fullName,
          email,
          createdAt: new Date()
        });
        console.log("User details saved in Firestore");
      } else {
        userCredential = await signInWithEmailAndPassword(auth, email, password);
        console.log("User signed in:", userCredential.user);
      }

      const idToken = await userCredential.user.getIdToken();
      console.log("Generated ID Token:", idToken);

      alert("Success! Check console for ID Token.");
      navigate("/MHMV-profile/profile");
    } catch (error) {
      console.error("Auth Error:", error);
      if (error.code === "auth/email-already-in-use") {
        alert("This email is already registered. Please Sign In instead.");
      } else if (error.code === "auth/wrong-password") {
        alert("Wrong password. Try again.");
      } else if (error.code === "auth/user-not-found") {
        alert("No account found. Please Sign Up first.");
      } else {
        alert("Authentication failed. Check console for details.");
      }
    }
  };

  return (
    <div>
    
    <div className="auth-overlay">
      <div className="auth-header">
        <BackButton text="Back" className="ghost" />
      </div>
      <div className="auth-box">
        {/* Fixed Close Button */}
        <button className="close-btn" onClick={handleClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <h2>Jobseeker {isSignup ? "Sign Up" : "Sign In"}</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {isSignup && (
            <input
              type="text"
              placeholder="Full Name"
              required
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          )}

          <button type="submit">{isSignup ? "Sign Up" : "Sign In"}</button>
        </form>

        <p
          onClick={() => setIsSignup(!isSignup)}
          className="toggle-link"
        >
          {isSignup ? "Already have an account? Sign In" : "Don't have an account? Sign Up"}
        </p>
      </div>
    </div>
    </div>
  );
}


export default JobSeekerAuth;